import React, { useState } from 'react';
import { mockData } from '../mock';
import { Card, CardContent } from './ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from './ui/tabs';
import { Button } from './ui/button';
import { Check, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const Services = () => {
  const navigate = useNavigate();

  return (
    <section id="services" className="py-24 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <span className="inline-block px-6 py-2 bg-[#F5F3ED] rounded-full text-[#1A3A2E] text-sm font-medium mb-6">
            Leistungen
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-[#1A3A2E] mb-4">
            Was wir für Sie tun können
          </h2>
        </div>

        <Tabs defaultValue="private" className="w-full">
          <TabsList className="grid w-full max-w-md mx-auto grid-cols-2 mb-12">
            <TabsTrigger value="private" className="text-lg">Privatkunden</TabsTrigger>
            <TabsTrigger value="business" className="text-lg">Geschäftskunden</TabsTrigger>
          </TabsList>
          <TabsContent value="private">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {mockData.services.map((service, idx) => (
                <Card
                  key={idx}
                  className="border-none shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden group"
                >
                  <div className="relative h-64 overflow-hidden">
                    <img
                      src={service.image}
                      alt={service.title}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    />
                  </div>
                  <CardContent className="p-8">
                    <h3 className="text-2xl font-bold text-[#1A3A2E] mb-6">{service.title}</h3>
                    <ul className="space-y-4">
                      {service.items.map((item, itemIdx) => (
                        <li key={itemIdx} className="flex items-start space-x-3">
                          <Check className="w-5 h-5 text-[#1A3A2E] flex-shrink-0 mt-1" />
                          <span className="text-[#1A3A2E]/70">{item}</span>
                        </li>
                      ))}
                    </ul>
                  </CardContent>
                </Card>
              ))}
            </div>
          </TabsContent>
          <TabsContent value="business">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {mockData.services.map((service, idx) => (
                <Card
                  key={idx}
                  className="border-none shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden group"
                >
                  <div className="relative h-64 overflow-hidden">
                    <img
                      src={service.image}
                      alt={service.title}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    />
                  </div>
                  <CardContent className="p-8">
                    <h3 className="text-2xl font-bold text-[#1A3A2E] mb-6">{service.title}</h3>
                    <ul className="space-y-4">
                      {service.items.map((item, itemIdx) => (
                        <li key={itemIdx} className="flex items-start space-x-3">
                          <Check className="w-5 h-5 text-[#1A3A2E] flex-shrink-0 mt-1" />
                          <span className="text-[#1A3A2E]/70">{item}</span>
                        </li>
                      ))}
                    </ul>
                  </CardContent>
                </Card>
              ))}
            </div>
          </TabsContent>
        </Tabs>

        <div className="mt-16 text-center">
          <Card className="border-none shadow-lg bg-[#F5F3ED]">
            <CardContent className="p-12">
              <h3 className="text-3xl font-bold text-[#1A3A2E] mb-8">
                Kontaktieren Sie uns für Ihren Auftrag
              </h3>
              <div className="flex flex-col md:flex-row gap-4 justify-center">
                <Button 
                  onClick={() => navigate('/waermepumpe')}
                  className="bg-[#1A3A2E] text-white hover:bg-[#2D4A3E] px-4 py-6 text-base md:text-lg whitespace-normal leading-tight"
                  lang="de"
                >
                  <span className="block hyphens-auto" style={{ wordBreak: 'break-word' }}>Wärme­pumpe anfragen</span>
                  <ArrowRight className="ml-2 flex-shrink-0" />
                </Button>
                <Button
                  variant="outline"
                  onClick={() => {
                    const element = document.querySelector('#contact');
                    if (element) element.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="border-2 border-[#1A3A2E] text-[#1A3A2E] hover:bg-[#1A3A2E] hover:text-white px-4 py-6 text-base md:text-lg whitespace-normal leading-tight"
                  lang="de"
                >
                  <span className="block hyphens-auto" style={{ wordBreak: 'break-word' }}>Anderes Bau­vorhaben anfragen</span>
                  <ArrowRight className="ml-2 flex-shrink-0" />
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default Services;